import { render, staticRenderFns } from "./resolve-incident.vue?vue&type=template&id=470e7b90&"
import script from "./resolve-incident.vue?vue&type=script&lang=js&"
export * from "./resolve-incident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports